import { Button } from "@/core/components/ui/button";
import {
  useGetAiScriptStatement,
  STATEMENT_IDENTITY,
} from "@/payroll/ai-script/query";
import { StatementRenderer } from "@/payroll/ai-script/statement/statement-renderer";
import { PackChatState } from "@/payroll/pack-chat/pack-chat-state";
import type {
  IPackChatSource,
  PackChatSourceAccess,
} from "@/payroll/pack-chat/types";

export const SourceStatement = ({
  source,
  access,
}: {
  source: IPackChatSource;
  access: PackChatSourceAccess;
}) => {
  const query = useGetAiScriptStatement(
    access.businessId,
    source.ai_script_run_id,
    access.technicianId
      ? {
          identity: STATEMENT_IDENTITY.technician,
          technicianId: access.technicianId,
          enabled: true,
        }
      : { identity: STATEMENT_IDENTITY.viewer, enabled: true },
  );
  if (query.isLoading) return <PackChatState compact loading />;
  if (query.isError) {
    return (
      <PackChatState
        compact
        error={query.error}
        title="Source PayPack couldn't be loaded"
        body="Try again. If it keeps failing, contact support."
        action={
          <Button
            variant="secondary"
            size="sm"
            onClick={() => void query.refetch()}
          >
            Try again
          </Button>
        }
      />
    );
  }
  if (
    query.data?.released === false ||
    query.data?.linked === false ||
    !query.data?.statement
  ) {
    return (
      <PackChatState
        compact
        title="Source PayPack unavailable"
        body="This statement is not available for this run right now."
      />
    );
  }
  return <StatementRenderer statement={query.data.statement} />;
};
